import React from "react";

import * as Pi from "react-icons/pi";

export default function TableList({ tables = [] }) {
  return (
    <div className="rs-left-list">
      <div className="rs-left rs-left--head">Table</div>
      {tables.map((t) => {
        const chairs = Number(t?.chairs) || 0;
        return (
          <div key={t.id} className="rs-left rs-left--row">
            <span
              className="rs-left__name"
              title={chairs ? `${t.name} (${chairs})` : t.name}
            >
              <span className="rs-left__name-text">{t.name}</span>
              {chairs > 0 && (
                <span className="rs-left__cap">({chairs})</span>
              )}
            </span>
            <span className="rs-left__chairs" title={`${chairs} chairs`}>
              <Pi.PiChairDuotone aria-hidden />
              <span className="rs-left__chairs-text">
                {chairs > 1 ? "1-" + chairs : chairs}
              </span>
            </span>
          </div>
        );
      })}
    </div>
  );
}
